import { render, staticRenderFns } from "./Engineering.vue?vue&type=template&id=0c0e65b3&scoped=true&"
import script from "./Engineering.vue?vue&type=script&lang=js&"
export * from "./Engineering.vue?vue&type=script&lang=js&"
import style0 from "./Engineering.vue?vue&type=style&index=0&id=0c0e65b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0e65b3",
  null
  
)

component.options.__file = "Engineering.vue"
export default component.exports